import {useEffect, useState} from "react";
import {getAllBuyers} from "../../api/Api";
import {AutoComplete} from "antd";
import {BuyerInvoiceProfile} from "./BuyerInvoiceProfile";

export const BuyerSelectWidget = ({selectedBuyer, onSelect, value, setValue, disabled=false, onApiFail, props}) => {
    const [buyers, setBuyers] = useState([]);
    const [options, setOptions] = useState([]);

    const [select, setSelect] = useState(true);

    useEffect(() => {
        getAllBuyers().then(data => {
            const b = data.map(val => {
                return {
                    key: val.id,
                    ...val,
                }
            })
            setBuyers(b);
        }).catch(e => {
            if (e.status === 401) {
                if (onApiFail) {
                    onApiFail();
                }
            }
        });
    }, [onApiFail]);

    const onChange = (data) => {
        setValue(data);
    }

    const onSearch = (text) => {
        const newOptions = buyers.filter(buyer => {
            const ltext = text.toLowerCase();
            return (buyer.firstname.toLowerCase().includes(ltext) || buyer.lastname.toLowerCase().includes(ltext) || `${buyer.firstname} ${buyer.lastname}`.toLowerCase().includes(ltext));
        }).map(val => {
            return {
                value: `${val.firstname} ${val.lastname}`,
                buyer: val
            }
        });
        setOptions(newOptions)
    }

    const selectBuyer = (val, option) => {
        console.log(`selected ${val} ${JSON.stringify(option)}`);
        if (onSelect) {
            onSelect(option.buyer);
        }
        setSelect(false);
    }

    const autoCompleteStyle = {
        width: 200
    }

    const clickBuyer = () => {
        setSelect(true && !disabled);
    }

    const autocomp = <AutoComplete options={options} style={autoCompleteStyle} value={value} placeholder={'Buyer'} onChange={onChange} onSearch={onSearch} onSelect={selectBuyer}>
    </AutoComplete>

    const card = (selectedBuyer) ? <div onClick={clickBuyer}><BuyerInvoiceProfile buyer={selectedBuyer} /></div> : <div />

    return (select || (selectedBuyer === null) || (selectedBuyer === undefined)) ? autocomp : card;
}